import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import t from "../../../helpers/t";
import { useSelector, reservationsActions } from "inbooma-api";
import { Biscuit } from "../../../../utils";
import { moment } from "../../../../../vendor";
import Loader from "../../../components/Loader";
import { in_array } from "../../../../utils/Helper";

const ShowLogDialog = ({ handleCloseDialog, dispatch, reservation }) => {
  const language = Biscuit.get("user.lang").replace("_", "-");
  const _log = useSelector((state) => state.reservations.getReservationLog);
  const [initialized, setInitialized] = useState(false);
  const [logPending, setLogPending] = useState(false);
  const [wifi, setWifi] = useState(null);
  const [bt, setBt] = useState(null);
  const [gps, setGps] = useState(null);
  const [countErrors, setCountErrors] = useState(0);

  useEffect(() => {
    if (!initialized) {
      dispatch(
        reservationsActions.getReservationLog({
          token: Biscuit.get("token"),
          reservation_id: reservation.id,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setLogPending(true);
      setInitialized(true);
    }
  }, []);
  const errors = ["ERROR", "APPERROR"];
  const appLogs = ["APPLOG"];
  const successes = ["RESERVATION", "ORDER"];
  const bluetoothStates = {
    PoweredOn: true,
    PoweredOff: false,
    null: false,
  };
  const gpsStates = {
    1: true,
    0: false,
    null: false,
  };
  const wifiStates = {
    wifi: true,
    null: false,
  };
  useEffect(() => {
    if (_log.success === "" || logPending === false) {
      return;
    }
    if (_log.success === true) {
      let bluetooth = null,
        loc = null,
        internet = null;
      let count = 0;
      _log.data.map((log, index) => {
        if (in_array(log.type, errors)) {
          count++;
        }
        if (in_array(log.type, appLogs)) {
          if (
            typeof bluetoothStates[log.log.bluetooth] === "undefined" ||
            !bluetoothStates[log.log.bluetooth]
          ) {
            bluetooth = false;
          } else {
            bluetooth = bluetoothStates[log.log.bluetooth];
          }
          if (typeof gpsStates[log.log.gps] === "undefined" || !gpsStates[log.log.gps]) {
            loc = false;
          } else {
            loc = gpsStates[log.log.gps];
          }
          if (
            typeof wifiStates[log.log.internet] === "undefined" ||
            !wifiStates[log.log.internet]
          ) {
            internet = false;
          } else {
            internet = wifiStates[log.log.internet];
          }
        }
      });
      setBt(bluetooth);
      setGps(loc);
      setCountErrors(count);
      setWifi(internet);
    }
    setLogPending(false);
  }, [_log]);

  const showCheck = (avail) => {
    return (
      <>
        {avail === null ? (
          <i
            style={{ color: "lightgrey", paddingLeft: "3px", paddingRight: "10px" }}
            className="fi fi-minus"
          ></i>
        ) : avail ? (
          <i
            style={{ color: "green", paddingLeft: "3px", paddingRight: "10px" }}
            className="fi fi-check"
          ></i>
        ) : (
          <i
            style={{ color: "red", paddingLeft: "3px", paddingRight: "10px" }}
            className="fi fi-x"
          ></i>
        )}
      </>
    );
  };

  return (
    <>
      {initialized && (
        <>
          <Dialog
            onClose={handleCloseDialog}
            aria-labelledby="changelogs-dialog-title"
            open={true}
            name="changeLogsDialog"
            id="multipleRecipientsDialog"
            maxWidth={"md"}
          >
            <header className="inb-multiple-recipients-header">
              <button
                onClick={handleCloseDialog}
                type="button"
                id="inb-multiple-recipients-dialog-close-button"
                className="button hollow secondary right button-close-multiple-recipients-dialog round"
                title={t("close show status")}
              >
                <i className="fi fi-x"></i>
              </button>
              <h4>{t("log", null, "capital")} </h4>

              {/* <label className="inb-form__controlLabel legendLabel"><a href="#"
                                                                        onClick={(e) => _showPopUp(e, 'voucher for temporary user')}><i
                className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i></a></label>*/}
            </header>
            {!logPending && typeof _log.data !== "undefined" && _log?.data?.length > 0 && (
              <>
                <div
                  id="inb-c-main-multiple-recipients"
                  className="inb-c-listing off-canvas-content"
                  data-off-canvas-content=""
                  key={"gdudk"}
                  style={{ minHeight: "50px" }}
                >
                  <div className="inb-c-item inb-c-item--recipient row" key={"Lizrefca"}>
                    <div className="medium-12 small-12 column" title={t("log entry")}>
                      <span style={{ color: "red" }}>{t("count of errors")}:</span>{" "}
                      <span>{countErrors}</span>{" "}
                      <span style={{ paddingRight: "8px", paddingLeft: "20px" }}>
                        {t("overall connectivity")}:
                      </span>
                      <span>
                        {t("bluetooth") + ": "}
                        {showCheck(bt)}
                        {t("gps") + ": "}
                        {showCheck(gps)}
                        {t("wifi") + ": "}
                        {showCheck(wifi)}
                      </span>
                    </div>
                  </div>
                </div>
              </>
            )}
            <div
              id="inb-c-main-multiple-recipients"
              className="inb-c-listing off-canvas-content"
              data-off-canvas-content=""
              key={"gdudssk"}
            >
              {!logPending && typeof _log.data !== "undefined" && _log?.data?.length > 0 ? (
                _log.data.map((log, index) => {
                  if (in_array(log.type, appLogs)) {
                    return (
                      <>
                        <div className="inb-c-item inb-c-item--recipient row" key={index}>
                          <div className="medium-12 small-12 column" title={t("log entry")}>
                            <span>{log.time + ": "}</span>
                            <span style={{ paddingRight: "8px" }}>{t(log.type)}:</span>
                            <span>
                              {t("bluetooth") + ": "}
                              {showCheck(
                                typeof bluetoothStates[log.log.bluetooth] !== "undefined" &&
                                  bluetoothStates[log.log.bluetooth],
                              )}
                              {t("gps") + ": "}
                              {showCheck(
                                typeof gpsStates[log.log.gps] !== "undefined" &&
                                  gpsStates[log.log.gps],
                              )}
                              {t("wifi") + ": "}
                              {showCheck(
                                typeof wifiStates[log.log.internet] !== "undefined" &&
                                  wifiStates[log.log.internet],
                              )}
                            </span>
                          </div>
                        </div>
                      </>
                    );
                  } else {
                    return (
                      <>
                        <div className="inb-c-item inb-c-item--recipient row" key={index}>
                          <div className="medium-12 small-12 column" title={t("log entry")}>
                            <span>{log.time + ": "}</span>
                            {in_array(log.type, errors) ? (
                              <>
                                <span style={{ color: "red", paddingRight: "8px" }}>
                                  {t(log.type)}:
                                </span>
                                <span>{log.log}</span>
                              </>
                            ) : in_array(log.type, successes) ? (
                              <>
                                <span style={{ color: "green", paddingRight: "8px" }}>
                                  {t(log.type)}:
                                </span>
                                <span>{log.log}</span>
                              </>
                            ) : (
                              <>
                                <span style={{ paddingRight: "8px" }}>{t(log.type)}:</span>{" "}
                                <span>{log.log}</span>
                              </>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  }
                })
              ) : logPending ? (
                <>
                  {" "}
                  <Loader mediumWidth={6} smallWidth={6} subLoaders={0} />
                </>
              ) : (
                <>
                  <div id="inb-app-collection-empty" className="inb-announcement">
                    <div className="inb-image-box">
                      <img src="assets/img/no_data.svg" />
                    </div>
                    <h3>{t("app_msg_collection_empty")}</h3>
                    <p>{t("app_msg_collection_empty_body")}</p>
                  </div>
                </>
              )}
            </div>
          </Dialog>
        </>
      )}
    </>
  );
};

export default ShowLogDialog;
